import { render, staticRenderFns } from "./ContactFormComponent.vue?vue&type=template&id=537b304c&"
import script from "./ContactFormComponent.vue?vue&type=script&lang=js&"
export * from "./ContactFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./ContactFormComponent.vue?vue&type=style&index=0&id=537b304c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports